import './TableInfo.styles.scss';

import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';

import { GameType } from '../../../../model/enumeration/GameType.enum';
import { Permission } from '../../../../model/enumeration/Permission.enum';
import { PokerRoom } from '../../../../model/enumeration/PokerRoom';
import authStore from '../../../../store/AuthStore';
import commonStore from '../../../../store/CommonStore';
import permissionStore from '../../../../store/PermissionStore';
import playerStore from '../../../../store/PlayerStore';
import tableStore from '../../../../store/TableStore';
import { formatNumber } from '../../table.render.utils';
import { TableInfoProps } from './TableInfo.types';

const TableInfo: FC<TableInfoProps> = ({ table, inSidebar }) => {
  const hasShowUniqueIdsPermission = useMemo(
    () => permissionStore.hasPermission(Permission.SHOW_UNIQUE_IDS),
    [authStore.authenticatedUser],
  );

  const hasManageBotsSeatingPermission = useMemo(
    () => permissionStore.hasPermission(Permission.MANAGE_BOTS_SEATING),
    [authStore.authenticatedUser],
  );

  const isMtt = useMemo(
    () => table.gameType.includes(GameType.MTT),
    [table.gameType],
  );

  return (
    table && (
      <div
        className="TableInfo-Component"
        key={table.id}
        style={{
          marginTop: inSidebar ? 8 : 0,
        }}
        data-ignore-outside-click={true}
      >
        <div>Table ID: {table.id}</div>
        <div>Table name: {table.name}</div>
        {hasShowUniqueIdsPermission && (
          <div>
            Unique IDs: {tableStore.getTableUniqueIds(table).join(', ')}
          </div>
        )}
        {table.room === PokerRoom.Pokerrrr2 && (
          <div>Club ID: {tableStore.getUnionByTable(table).club}</div>
        )}
        {table.room === PokerRoom.FishPoker && (
          <div>League: {tableStore.getLeaguesByTable(table).join(', ')}</div>
        )}
        <div>
          Table limit: {commonStore.convertLimit(table.limit)}/
          {formatNumber(table.limitInUsd)}$
        </div>
        {inSidebar && <div>Game ID: {table.gameId || '--'}</div>}
        <div>
          Game type: {table.gameType}
          {table.gameType === GameType.MIX ? ` (${table.currentGameType})` : ''}
        </div>
        <div>
          Players: {table.players.filter(player => player).length}/
          {table.players.length}
          {isMtt && table.mttRemainingPlayers
            ? ` (${table.mttRemainingPlayers})`
            : ''}
        </div>
        <div>Game started: {table.gameId ? 'Yes' : 'No'}</div>
        {inSidebar && (
          <div className="players-amount-box">
            {hasManageBotsSeatingPermission && (
              <div className="waitlist-count">
                <i className="pi pi-calendar-clock stat-icon" />
                <span>{table.waitlistCount}</span>
              </div>
            )}
            <div className="viewers-amount">
              <i className="pi pi-eye stat-icon" />
              <span>{table.viewersCount}</span>
            </div>
            <div className="bots-amount">
              <img
                className="stat-icon"
                src="/assets/bot-stats.svg"
                alt="lp"
                width="24"
                height="24"
              />
              <span>
                {table.players.filter(player => player?.myBot).length}
              </span>
            </div>
            <div className="live-players-amount">
              <img
                className="stat-icon"
                src="/assets/player-stats.svg"
                alt="lp"
                width="24"
                height="24"
              />
              <span>{playerStore.findLivePlayersCount(table)}</span>
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default observer(TableInfo);
